import * as Factory from 'factory.ts'
import faker from 'faker'

import { type FinancialAccountMonthlySummary } from '@webapp/models/FinancialAccountMonthlySummary'

export const FinancialAccountMonthlySummaryMock =
  Factory.Sync.makeFactory<FinancialAccountMonthlySummary>({
    closing_balance: Factory.each(() => faker.finance.amount().toString()),
    opening_balance: Factory.each(() => faker.finance.amount().toString()),
    deposits_total: Factory.each(() => faker.finance.amount().toString()),
    deposits_count: Factory.each(() => faker.random.number()),
    withdrawals_total: Factory.each(() => faker.finance.amount().toString()),
    withdrawals_count: Factory.each(() => faker.random.number()),
  })
